import React, { useState, useRef, useEffect, useCallback, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import "./Assets.scss";
import Sidebar from "../SideBar/SideBar";
import Loader from "../Loader";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Checkbox,
  InputAdornment,
  Switch,
  Stack,
  FormControlLabel,
  Typography,
  ButtonGroup,
  Button,
} from "@mui/material";
import PropTypes, { symbol } from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import zec from "../../Img/coins/zec.png";
import xec from "../../Img/coins/xec.png";
import kcs from "../../Img/coins/kcs.png";
import scr from "../../Img/coins/scr.png";
import cat from "../../Img/coins/cat.png";
import woop from "../../Img/coins/woop.png";
import pip from "../../Img/coins/pip.png";
import insp from "../../Img/coins/xec.png";
import ese from "../../Img/coins/ese.png";
import sol from "../../Img/coins/sol.png";
import eye from "../../Img/eye.svg";
import eye_hide from "../../Img/eye_hide.svg";
import usercalls from "../../Axios";
import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import Avatar from "@mui/material/Avatar";
import { useQuery } from "react-query";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footernew from "../Footer/Footernew";
import { closeSVGIcon } from "@transak/transak-sdk";
import Transfer from "../Trade/Transfer";
import Context from "../../Context";
import { Capitalize } from "../../Helpers/StringFunctions";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export default function Spot() {
  const theme = useTheme();
  const medium = useMediaQuery(theme.breakpoints.up("lg"));

  const data1 = [2, 4, 5, 7, 5, 6, 7, 8, 9, 6, 9, 8]; // Sample data
  const pnl = 0.00045; // Today's PNL
  const percentageChange = 0.3; // Percentage change

  const height = 50; // Height of the graph
  const maxValue = Math.max(...data1);
  const minValue = Math.min(...data1);

  const navigate = useNavigate();

  // Generate SVG points with full-width scaling
  const points = data1
    .map((value, index) => {
      const x = (index / (data1.length - 1)) * 100; // X scaled to percentage (0-100%)
      const y = height - ((value - minValue) / (maxValue - minValue)) * height; // Y scaled based on data range
      return `${x},${y}`;
    })
    .join(" ");

  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [load, setLoad] = useState(false);

  const [imghide, setimghide] = useState([
    { show: true },
    { show: false },
    { show: true },
  ]);

  const assetData = [
    {
      title: "Spot Assets",
      balance: "0.0000",
      depositLink: "/deposit",
      withdrawLink: "/withdraw",
      convertLink: "/instant",
    },
  ];

  const showimg = (i) => {
    setimghide((prevData) =>
      prevData.map((item, index) =>
        index === i ? { ...item, show: !item.show } : item
      )
    );
  };

  const {
    setAssetName,
    assetName
  } = useContext(Context);

  const [changeType, setChangeType] = useState("spot");

  const [wallets, setWallets] = useState({});
  const [datas, setDatas] = useState([]);
  const path = usercalls();

  const [totalCount, setTotalCount] = useState(0);

  const [walletLoading, setWalletLoading] = useState(false);

  const [usdtBalance, setUsdtBalance] = useState(0);

  const [totalAsset, setTotalAsset] = useState("");

  const [totalAss, setTotalAss] = useState("");

  const [totalUSDT, setTotalUSDT] = useState(0);

  const getWalletsData = async (search) => {
    try {
      setLoad(true);
      // get wallets data
      setWalletLoading(true);
      setDatas([]);
      setTotalCount(0);
      const url = `${consts.BackendUrl}/wallet/OwnWalletGet?page=${
        page + 1
      }&limit=${rowsPerPage}`;
      const response = await path.postCall({
        url,
        payload: { search: search ? search : "", hideZero, changeType },
      });
      const result = await response.json();
      if (result.success) {
        setWallets(result.result);
        setDatas(result.result.docs);
        setTotalUSDT(result?.grandTotal);
        if (changeType === "future") {
          setTotalCount(1);
        } else {
          setTotalCount(result?.result?.totalDocs);
        }
        var res = result.result.docs;
        var objs = {};
        var arrs = [];
        for (let i = 0; i < res?.length; i++) {
          const element = res[i];

          if (element?.symbol == "USDT") {
            // setTotalUSDT(element?.spot_balance);
            setLoad(false);
          } else if (element?.spot_balance > 0) {
            objs[`${element?.symbol}USDT`] = element?.spot_balance;
            arrs.push(`${element?.symbol}USDT`);
            setLoad(false);
          }
        }
        setLoad(false);
        // console.log(arrs, "arrs");
        setTotalAsset(arrs);
        setTotalAss(objs);
        // console.log(objs, "objsobjs");
      }
      setWalletLoading(false);
      setLoad(false);
    } catch (error) {
      setWalletLoading(false);
      console.log("🚀 ~ getWalletsData ~ error:", error);
      setLoad(false);
    }
  };


  const [AssetChange, setAssetChange] = useState("")

  useEffect(() => {
    if (AssetChange) {
      getWalletsData()
    }
  }, [AssetChange])

  // Debounced function
  const debouncedSubmit = useCallback(
    debounce((value) => {
      getWalletsData(value);
    }, 300), // 300ms debounce delay
    []
  );

  // Effect to call debounced function when search changes
  useEffect(() => {
    debouncedSubmit(searchTerm);
  }, [searchTerm, debouncedSubmit]);

  useEffect(() => {
    getWalletsData();
  }, [page, hideZero, changeType]);

  const filteredData = datas.filter((row) => {
    const matchesSearch = row.assetname
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const futureData = datas.filter((item) => item.symbol === "USDT");
  const dataToRender = changeType === "future" ? futureData : datas;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const options = {
    loop: false,
    nav: false,
    dots: false,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
  };

  const transaction = [
    {
      coinName: "Welcome Bonus",
      icon: zec,
      date: "Aug 7th 2024, 1:43 pm",
      value: "25000",
    },
    {
      coinName: "Welcome Bonus",
      icon: zec,
      date: "Aug 7th 2024, 1:43 pm",
      value: "25000",
    },
    {
      coinName: "Welcome Bonus",
      icon: zec,
      date: "Aug 7th 2024, 1:43 pm",
      value: "25000",
    },
    {
      coinName: "Welcome Bonus",
      icon: zec,
      date: "Aug 7th 2024, 1:43 pm",
      value: "25000",
    },
    {
      coinName: "Welcome Bonus",
      icon: zec,
      date: "Aug 7th 2024, 1:43 pm",
      value: "25000",
    },
  ];

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getHistory = async () => {
    setLoad(true);
    const url = `${consts.BackendUrl}/wallet/getOwnDepositHistory?page=1&limit=5`;
    const response = await path.postCall({ url });
    const result = await response.json();
    setLoad(false);

    return result;
  };

  const {
    data: history,
    error: historyerror,
    isLoading: historyloading,
  } = useQuery(["getHistory"], getHistory, {
    refetchOnWindowFocus: false, // Prevent refetching when window gains focus
    retry: 0,
  });

  // useEffect(() => {
  //   const fetchBnbPrice = async () => {
  //     try {
  //       if (totalAsset?.length > 0) {
  //         const response = await axios.get(`https://api.binance.com/api/v3/ticker/price?symbols=${JSON?.stringify(totalAsset)}`);
  //         console.log(response?.data, "teststeets")
  //         var resdata = response?.data
  //         if (resdata?.length > 0) {
  //           var total = 0
  //           for (let i = 0; i < resdata?.length; i++) {
  //             const element = resdata[i];
  //             total += totalAss[`${element?.symbol}`] * element?.price
  //           }
  //           setTotalUSDT((total + totalUSDT)?.toFixed(4))
  //         }
  //         // setBnbPriceInUsdt(parseFloat(response.data.price)); // Get the price of BNB in USDT
  //       }
  //     } catch (error) {
  //       console.error("Error fetching BNB price from Binance API:", error);
  //     }
  //   };

  //   fetchBnbPrice();
  // }, [totalAsset]);

  return (
    <div className="spot-full menu-responsive">
      <div>
        <Header />
        {/* {load && <Loader />} */}
        <div className="main_flx">
          <Sidebar />
          <div className="dash_board">
            <div className="abvbar split_half display-2 flex-wrap">
              <h6>Wallet</h6>
            </div>

            <div className="crypto-inr split_half">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Crypto" {...a11yProps(0)} />
                {/* <Tab label="INR" {...a11yProps(1)} /> */}
              </Tabs>
              <CustomTabPanel value={value} index={0}>
                <div className="mb-4">
                  <Grid container spacing={3}>
                    {assetData.map((row, i) => (
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="asset_box box_bdr display-2">
                          <div>
                            <p
                              className={` ${
                                imghide[i].show ? "show" : "hide"
                              }`}
                            >
                              {Capitalize(changeType)} Assets
                              <span
                                className="cusrsor-pointer"
                                onClick={() => showimg(i)}
                              >
                                {imghide[i]?.show ? (
                                  <img src={eye} alt="img" />
                                ) : (
                                  <img src={eye_hide} alt="img" />
                                )}
                              </span>
                            </p>
                            <h2>
                              {imghide[i].show ? totalUSDT : "*****"} USDT{" "}
                            </h2>
                            <div className="flx">
                              {row.depositLink && (
                                <Link
                                  to={row.depositLink}
                                  className="org_btn radius"
                                >
                                  Deposit
                                </Link>
                              )}
                              {row.withdrawLink && (
                                <Link
                                  to={row.withdrawLink}
                                  className="bdr_btn radius"
                                >
                                  Withdraw
                                </Link>
                              )}
                              {row.convertLink && (
                                <Link
                                  to={row.convertLink}
                                  className="bdr_btn radius"
                                >
                                  Convert
                                </Link>
                              )}
                              {row.convertLink && (
                                <div className="bdr_btn radius">
                                  <Transfer changeType={changeType} setAssetChange={setAssetChange} />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="custom_table box_bdr">
                        <div className="h_flx flex-wrap gap-10">
                          <h3>Assets</h3>
                          <h3
                            onClick={() => {
                              setChangeType("funding");
                              setPage(0);
                            }}
                            className={
                              changeType === "funding"
                                ? "active assetTab"
                                : "assetTab"
                            }
                          >
                            Funding
                          </h3>
                          <h3
                            onClick={() => {
                              setChangeType("spot");
                              setPage(0);
                            }}
                            className={
                              changeType == "spot"
                                ? "active assetTab"
                                : "assetTab"
                            }
                          >
                            Spot
                          </h3>
                          <h3
                            onClick={() => {
                              setChangeType("margin");
                              setPage(0);
                            }}
                            className={
                              changeType == "margin"
                                ? "active assetTab"
                                : "assetTab"
                            }
                          >
                            Margin
                          </h3>
                          <h3
                            onClick={() => {
                              setChangeType("future");
                              setPage(0);
                            }}
                            className={
                              changeType == "future"
                                ? "active assetTab"
                                : "assetTab"
                            }
                          >
                            Future
                          </h3>
                          <div className="input_box">
                            <TextField
                              fullWidth
                              placeholder="Currency Name, Symbol"
                              sx={{
                                width: "240px",
                                borderRadius: "50px",
                                "& .MuiInputBase-formControl": {
                                  borderRadius: "50px",
                                },
                                "& .MuiInputBase-input": {
                                  padding: "11px  0 11px 30px",
                                  border: "0",
                                },
                                "& fieldset": {
                                  border: "1px solid #d3d1d1 !important",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  color: "black",
                                  fontSize: "15px",
                                },
                              }}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <svg
                                      width="18"
                                      height="19"
                                      viewBox="0 0 18 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_55_24278)">
                                        <path
                                          d="M16.6 18.3984L10.3 12.0984C9.8 12.4984 9.225 12.8151 8.575 13.0484C7.925 13.2817 7.23333 13.3984 6.5 13.3984C4.68333 13.3984 3.14583 12.7692 1.8875 11.5109C0.629167 10.2526 0 8.7151 0 6.89843C0 5.08177 0.629167 3.54427 1.8875 2.28593C3.14583 1.0276 4.68333 0.398438 6.5 0.398438C8.31667 0.398438 9.85417 1.0276 11.1125 2.28593C12.3708 3.54427 13 5.08177 13 6.89843C13 7.63177 12.8833 8.32343 12.65 8.97343C12.4167 9.62343 12.1 10.1984 11.7 10.6984L18 16.9984L16.6 18.3984ZM6.5 11.3984C7.75 11.3984 8.8125 10.9609 9.6875 10.0859C10.5625 9.21093 11 8.14843 11 6.89843C11 5.64843 10.5625 4.58593 9.6875 3.71093C8.8125 2.83593 7.75 2.39843 6.5 2.39843C5.25 2.39843 4.1875 2.83593 3.3125 3.71093C2.4375 4.58593 2 5.64843 2 6.89843C2 8.14843 2.4375 9.21093 3.3125 10.0859C4.1875 10.9609 5.25 11.3984 6.5 11.3984Z"
                                          fill="#1E2329"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_55_24278">
                                          <rect
                                            width="18"
                                            height="19"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                        <div className="switch_box">
                          <FormControlLabel
                            control={
                              <Switch
                                checked={hideZero}
                                onChange={(e) => setHideZero(e.target.checked)}
                                sx={{
                                  "& .Mui-checked": {
                                    color: "#566FFF !important",
                                  },
                                  "& .Mui-checked+.MuiSwitch-track": {
                                    backgroundColor: "#566FFF !important",
                                  },
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "12px",
                                  },
                                }}
                              />
                            }
                            label="Hide Zero Balance"
                          />
                        </div>

                        <TableContainer sx={{ marginBottom: "10px" }}>
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Currency Symbol</TableCell>
                                <TableCell>Currency Name</TableCell>
                                <TableCell>Available Balance</TableCell>
                                {/* <TableCell>USDT Price</TableCell> */}
                                {changeType != "funding" && (
                                  <TableCell>Escrow Balance</TableCell>
                                )}
                                {changeType == "margin" && (
                                  <TableCell>Debt Amount</TableCell>
                                )}
                                <TableCell align="center">Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {walletLoading == true ? (
                                <TableRow>
                                  <TableCell colSpan={8}>
                                    <div className="inline-loader">
                                      <Loader />
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                datas?.length == 0 && (
                                  <TableRow>
                                    <TableCell colSpan={8}>
                                      <div
                                        className="model-load"
                                        style={{
                                          color: "white",
                                          textAlign: "center",
                                        }}
                                      >
                                        No Data Found
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                )
                              )}
                              {dataToRender?.length > 0 &&
                                dataToRender?.map((row, index) => (
                                  <TableRow key={row._id} className="tr_row">
                                    <TableCell>
                                      {page == 0
                                        ? index + 1
                                        : page * 10 + index + 1}
                                    </TableCell>
                                    <TableCell>
                                      <div className="d-flex align-items-center display-1">
                                        {/* <Avatar sx={{ width: 24, height: 24 }}>  {row?.symbol?.split('')[0]}</Avatar> */}
                                        <ImageWithFallback
                                          src={
                                            row?.image
                                              ? row?.image
                                              : `${consts?.imageurl}${row?.symbol}.png`
                                          }
                                          alt={row.assetname}
                                          name={row.symbol}
                                          size={30}
                                          style={{
                                            // width: "30px",
                                            // height: "30px",
                                            marginRight: "10px",
                                            // borderRadius: "50%",
                                          }}
                                        />
                                        {row?.symbol}
                                      </div>
                                    </TableCell>
                                    <TableCell>{row?.assetname}</TableCell>
                                    {changeType == "funding" && (
                                      <>
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {(row?.funding_balance).toFixed(
                                                6
                                              )}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_available
                                                ? `${row?.usdtValue_available}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                        {/* <TableCell>
                                          {row?.symbol === "USDT"
                                            ? row?.funding_balance.toFixed(6)
                                            : row?.usdtValue ? Number(row?.usdtValue)?.toFixed(6) : 0}
                                        </TableCell> */}
                                      </>
                                    )}
                                    {changeType == "spot" && (
                                      <>
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {(row?.spot_balance).toFixed(6)}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_available
                                                ? `${row?.usdtValue_available}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                        {/* <TableCell>
                                          {row?.symbol === "USDT"
                                            ? row?.spot_balance.toFixed(6)
                                            : row?.usdtValue ? Number(row?.usdtValue)?.toFixed(6) : 0}
                                        </TableCell> */}
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {Number(
                                                row?.escrow_spot_balance
                                              ).toFixed(6)}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_escrow
                                                ? `${row?.usdtValue_escrow}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                      </>
                                    )}
                                    {changeType == "margin" && (
                                      <>
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {(row?.margin_balance).toFixed(6)}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_available
                                                ? `${row?.usdtValue_available}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                        {/* <TableCell>
                                          {row?.symbol === "USDT"
                                            ? row?.margin_balance.toFixed(6)
                                            : row?.usdtValue ? Number(row?.usdtValue)?.toFixed(6) : 0}
                                        </TableCell> */}
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {(row?.escrow_margin_balance).toFixed(
                                                6
                                              )}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_escrow
                                                ? `${row?.usdtValue_escrow}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {(row?.margin_debt_amount).toFixed(
                                                6
                                              )}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_debt
                                                ? `${row?.usdtValue_debt}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                      </>
                                    )}

                                    {changeType == "future" && (
                                      <>
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {(row?.future_balance).toFixed(6)}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_available
                                                ? `${row?.usdtValue_available}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                        {/* <TableCell>
                                          {row?.symbol === "USDT"
                                            ? row?.future_balance.toFixed(6)
                                            : row?.usdtValue ? Number(row?.usdtValue)?.toFixed(6) : 0}
                                        </TableCell> */}
                                        <TableCell>
                                          <div className="">
                                            <div>
                                              {(row?.escrow_future_balance).toFixed(
                                                6
                                              )}
                                            </div>
                                            <div className="dim-clr">
                                              {row?.usdtValue_escrow
                                                ? `${row?.usdtValue_escrow}  USD`
                                                : "0 USD"}
                                            </div>
                                          </div>
                                        </TableCell>
                                      </>
                                    )}
                                    <TableCell>
                                      <div className="display-3 gap-10 table-link justi-c">
                                        {row?.DepositStatus == true ? (
                                          <div
                                            onClick={() => {
                                              navigate("/deposit", {
                                                state: { symbol: row?.symbol },
                                              });
                                            }}
                                          >
                                            <div
                                              style={{
                                                color: "#566FFF",
                                                cursor: "pointer",
                                              }}
                                            >
                                              Deposit
                                            </div>
                                          </div>
                                        ) : (
                                          <Tooltip
                                            title="Deposit Disabled"
                                            arrow
                                            placement="top"
                                          >
                                            <div
                                              style={{
                                                color: "rgb(86 111 255 / 49%)",
                                                cursor: "pointer",
                                              }}
                                            >
                                              Deposit
                                            </div>
                                          </Tooltip>
                                        )}

                                        <div>
                                          {row?.WithdrawStatus == true ? (
                                            <div
                                              onClick={() => {
                                                navigate("/withdraw", {
                                                  state: {
                                                    symbol: row?.symbol,
                                                  },
                                                });
                                              }}
                                            >
                                              <div
                                                style={{
                                                  color: "#566FFF",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                Withdraw
                                              </div>
                                            </div>
                                          ) : (
                                            <Tooltip
                                              title="Withdraw Disabled"
                                              arrow
                                              placement="top"
                                            >
                                              <div
                                                style={{
                                                  color:
                                                    "rgb(86 111 255 / 49%)",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                Withdraw
                                              </div>
                                            </Tooltip>
                                          )}
                                        </div>
                                        <div>
                                          <Link to="/instant" state={row?._id}>
                                            Convert
                                          </Link>
                                        </div>
                                        <div className="table-trns" onClick={() => { setAssetName(row?.symbol) }} >
                                          {/* <Button>
                                            Transfer{" "}
                                          </Button>
                                          {
                                            assetName && */}
                                          <Transfer changeType={changeType} setAssetChange={setAssetChange} handOpen={Math.floor(6)} />
                                          {/* } */}
                                        </div>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[]} // Options for rows per page
                            component="div"
                            count={totalCount} // Total number of filtered rows
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            // onRowsPerPageChange={handleChangeRowsPerPage}
                          />
                        </TableContainer>
                      </div>

                      <div className="custom_table box_bdr mt-20">
                        <div className="h_flx">
                          <h3>Recent Transaction</h3>
                          <div>
                            <Link to="/deposit" className="more-link">
                              More
                            </Link>
                          </div>
                        </div>
                        {history?.result?.docs?.length > 0 &&
                          history?.result?.docs?.map((row) => {
                            return (
                              <div className="h_flx recent-transction  mt-20">
                                <div className="display-1">
                                  <div>
                                    {" "}
                                    <Avatar sx={{ width: 35, height: 35 }}>
                                      {" "}
                                      {row?.asset?.split("")[0]}
                                    </Avatar>
                                    {/* <img
                                    src={row.icon}
                                    alt="Coin"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      marginRight: "10px",
                                      borderRadius: "50%",
                                    }}
                                  /> */}
                                  </div>
                                  <div>
                                    <p>Deposit: {row?.asset} </p>
                                    <span>{row?.createdAt?.split("T")[0]}</span>
                                  </div>
                                </div>
                                <div className="transaction-value">
                                  <p>{row?.amount}</p>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <div className="mb-4">
                  <Grid container spacing={3}>
                    {assetData.map((row, i) => (
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="asset_box box_bdr display-2">
                          <div>
                            <p
                              className={` ${
                                imghide[i].show ? "show" : "hide"
                              }`}
                            >
                              {row.title}
                              <span
                                className="cusrsor-pointer"
                                onClick={() => showimg(i)}
                              >
                                {imghide[i]?.show ? (
                                  <img src={eye} alt="img" />
                                ) : (
                                  <img src={eye_hide} alt="img" />
                                )}
                              </span>
                            </p>
                            <h2>
                              {imghide[i].show ? row.balance : "*****"} USDT{" "}
                            </h2>
                            <div className="flx">
                              {row.depositLink && (
                                <Link
                                  to={row.depositLink}
                                  className="org_btn radius"
                                >
                                  Deposit
                                </Link>
                              )}
                              {row.withdrawLink && (
                                <Link
                                  to={row.withdrawLink}
                                  className="bdr_btn radius"
                                >
                                  Withdraw
                                </Link>
                              )}
                              {row.convertLink && (
                                <Link
                                  to={row.convertLink}
                                  className="bdr_btn radius"
                                >
                                  Convert
                                </Link>
                              )}
                            </div>
                          </div>
                          <div>
                            <svg
                              width="18"
                              height="20"
                              viewBox="0 0 18 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.74761 15.0491C8.74788 14.1383 8.98888 13.2445 9.44525 12.4616C9.90163 11.6788 10.5565 11.0357 11.341 10.6003C12.1255 10.1648 13.0106 9.95294 13.9032 9.98701C14.7958 10.0211 15.6629 10.2998 16.4132 10.7938C16.4185 10.4185 16.4214 10.0179 16.4214 9.5857C16.4214 7.36343 16.3472 5.97644 16.2008 4.53979H16.2216C16.1406 3.73924 15.8407 2.97797 15.3562 2.34267C14.8716 1.70737 14.2218 1.22357 13.4808 0.946363C13.4416 0.931248 13.4025 0.916853 13.3629 0.903177C13.0701 0.80281 12.7673 0.735588 12.4601 0.702722L12.4308 0.699483C11.2586 0.576764 11.0705 0.478516 8.59866 0.478516C6.12687 0.478516 5.72696 0.576764 4.55584 0.701283L4.52654 0.704522C4.204 0.739058 3.88646 0.811516 3.58025 0.920451V0.904257C2.81674 1.16894 2.14366 1.65129 1.64082 2.29412C1.13797 2.93694 0.826437 3.7133 0.743144 4.53115C0.596312 5.97068 0.521484 7.35911 0.521484 9.5857C0.521484 11.8123 0.596312 13.2007 0.743144 14.6403C0.843408 15.6226 1.27197 16.5399 1.95693 17.2382C2.64189 17.9365 3.54157 18.3734 4.50501 18.4755L4.53431 18.4788C5.70649 18.6033 5.89427 18.7015 8.36606 18.7015C9.18493 18.7015 9.77791 18.6907 10.2435 18.6717C9.76936 18.2004 9.39271 17.637 9.13579 17.0148C8.87886 16.3926 8.74687 15.7242 8.74761 15.0491ZM4.61796 5.27035H12.3235C12.5464 5.27035 12.7603 5.36067 12.918 5.52143C13.0756 5.6822 13.1642 5.90024 13.1642 6.12759C13.1642 6.35495 13.0756 6.57299 12.918 6.73375C12.7603 6.89452 12.5464 6.98483 12.3235 6.98483H4.61972C4.39674 6.98483 4.18289 6.89452 4.02522 6.73375C3.86755 6.57299 3.77897 6.35495 3.77897 6.12759C3.77897 5.90024 3.86755 5.6822 4.02522 5.52143C4.18289 5.36067 4.39674 5.27035 4.61972 5.27035H4.61796ZM4.61796 10.6531C4.39791 10.6485 4.1884 10.5562 4.03437 10.3959C3.88035 10.2356 3.79408 10.0201 3.79408 9.79569C3.79408 9.57129 3.88035 9.35582 4.03437 9.19552C4.1884 9.03523 4.39791 8.94287 4.61796 8.93827H9.01268C9.12457 8.93594 9.23578 8.95639 9.33982 8.99843C9.44385 9.04047 9.53861 9.10325 9.61854 9.1831C9.69848 9.26295 9.76198 9.35826 9.80534 9.46345C9.84869 9.56864 9.87102 9.68159 9.87102 9.79569C9.87102 9.90979 9.84869 10.0227 9.80534 10.1279C9.76198 10.2331 9.69848 10.3284 9.61854 10.4083C9.53861 10.4881 9.44385 10.5509 9.33982 10.593C9.23578 10.635 9.12457 10.6555 9.01268 10.6531H4.61796Z"
                                fill="#8C8C8C"
                              />
                              <path
                                d="M14.2168 11.8086C13.469 11.8086 12.7379 12.0347 12.1161 12.4583C11.4942 12.882 11.0096 13.4841 10.7234 14.1886C10.4372 14.8931 10.3623 15.6683 10.5082 16.4162C10.6541 17.1641 11.0142 17.851 11.5431 18.3902C12.0719 18.9294 12.7456 19.2966 13.4791 19.4454C14.2126 19.5941 14.9729 19.5178 15.6639 19.226C16.3548 18.9342 16.9454 18.44 17.3608 17.806C17.7763 17.172 17.9981 16.4265 17.9981 15.664C17.9981 14.6415 17.5997 13.6609 16.8906 12.9378C16.1815 12.2148 15.2197 11.8086 14.2168 11.8086ZM15.7155 16.2283H14.1416C14.0223 16.2283 13.9078 16.18 13.8234 16.0939C13.739 16.0079 13.6916 15.8912 13.6916 15.7695V13.3043C13.6916 13.1826 13.739 13.0659 13.8234 12.9798C13.9078 12.8938 14.0223 12.8454 14.1416 12.8454C14.261 12.8454 14.3755 12.8938 14.4599 12.9798C14.5443 13.0659 14.5917 13.1826 14.5917 13.3043V15.3106H15.7155C15.8349 15.3106 15.9493 15.359 16.0337 15.445C16.1181 15.5311 16.1655 15.6478 16.1655 15.7695C16.1655 15.8912 16.1181 16.0079 16.0337 16.0939C15.9493 16.18 15.8349 16.2283 15.7155 16.2283Z"
                                fill="#8C8C8C"
                              />
                            </svg>
                          </div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="custom_table box_bdr mt-20">
                        <div className="h_flx">
                          <h3>Recent Transaction</h3>
                          <div>
                            <Link to="" className="more-link">
                              More
                            </Link>
                          </div>
                        </div>

                        {transaction.map((row) => {
                          return (
                            <div className="h_flx recent-transction  mt-20">
                              <div className="display-1">
                                <div>
                                  {" "}
                                  <img
                                    src={row.icon}
                                    alt="Coin"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      marginRight: "10px",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </div>
                                <div>
                                  <p>{row.coinName}</p>
                                  <span>{row.date}</span>
                                </div>
                              </div>
                              <div className="transaction-value">
                                <p>{row.value}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </CustomTabPanel>
            </div>
          </div>
        </div>
      </div>
      <Footernew />
    </div>
  );
}
